/** Shared constants for user profile Firestore services. */

export const USERS_COLLECTION = 'users';

export const DEFAULT_TIER = 'free';

export const VALID_TIERS = new Set(['free', 'lite', 'pro']);

export const VALID_WALL_TYPES = new Set([
  'project_limit',
  'gcal_locked',
  'dashboard_scroll',
]);

export const DEV_TIER_CHANGED_EVENT = 'todoes-dev-tier-changed';

/** @param {string} userId */
export const devTierStorageKey = (userId) => `dev-tier-${userId}`;

/** Dev-only local override (Vite dev server); tests/production use Firestore. */
export function isDevTierLocalOverrideEnabled() {
  return import.meta.env.DEV && import.meta.env.MODE !== 'test';
}
